import React from 'react';
import { UniverseModuleType } from 'src/domains/common/universes.type';
import { features } from './properbet.features';
import { themeColors } from './properbet.config';
import { ProperBetLogotype } from './properbet.logotype';
import { ProperBetLogo } from 'src/layouts/LoginPage/logos/ProperBetLogo';
import ProperBetLoginImage from 'src/layouts/LoginPage/loginBgImages/ProperBetLoginImage.png';
import { ProperBetBrandIconWrapper, CompliancePopupLogo } from './properbet.style';
import { LoginImageWrapper } from 'src/layouts/LoginPage/LoginImage.style';

export const universeModule: UniverseModuleType = {
    themeColors,
    features,
    title: 'Proper Bet Backoffice',
    urls: {
        website: 'https://proper.bet/',
        backoffice: 'https://backoffice.proper.bet/',
    },
    BrandIcon: () => <ProperBetBrandIconWrapper />,
    Logotype: () => <ProperBetLogotype />,
    LogotypeLoginPage: () => <ProperBetLogo />,
    compliancePopupLogo: () => <CompliancePopupLogo />,
    loginImageContainer: () => <LoginImageWrapper imgSrc={ProperBetLoginImage} />,
};
